<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <a [routerLink]="['/dash/settings/venue-configuration']" class="btn btn-outline-secondary me-3">
          <i class="fas fa-arrow-left"></i> Back to Venue Configuration
        </a>
        <h4 class="mb-0">EQ Track Management</h4>
      </div>
      <div>
        <button *ngIf="!editMode" class="btn btn-primary me-2" (click)="toggleEditMode()">
          Edit Tracks
        </button>
        <button *ngIf="!editMode" class="btn btn-success" (click)="addNewTrack()">
          Add New Track
        </button>
        <ng-container *ngIf="editMode">
          <button class="btn btn-success me-2" (click)="saveChanges()">
            Save Changes
          </button>
          <button class="btn btn-secondary" (click)="cancelEdit()">
            Cancel
          </button>
        </ng-container>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Track Name</th>
              <th>Track ID</th>
              <th>Race Length (m)</th>
              <th>Track Type</th>
              <th>Additional Start (m)</th>
              <th>Track Length (m)</th>
              <th *ngIf="editMode">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let track of tracks; let i = index">
              <td>
                <input *ngIf="editMode" type="text" class="form-control" [(ngModel)]="track.EQTrackName" required>
                <span *ngIf="!editMode">{{track.EQTrackName}}</span>
              </td>
              <td>
                <input *ngIf="editMode" type="text" class="form-control" [(ngModel)]="track.TrackID" required>
                <span *ngIf="!editMode">{{track.TrackID}}</span>
              </td>
              <td>
                <input *ngIf="editMode" type="number"
                       class="form-control"
                       [(ngModel)]="track.RaceLength"
                       step="0.1"
                       min="0"
                       required>
                <span *ngIf="!editMode">{{track.RaceLength.toFixed(1)}}</span>
              </td>
              <td>
                <input *ngIf="editMode" type="text" class="form-control" [(ngModel)]="track.TrackType" required>
                <span *ngIf="!editMode">{{track.TrackType}}</span>
              </td>
              <td>
                <input *ngIf="editMode" type="text" class="form-control" [(ngModel)]="track.AdditionalStart" required>
                <span *ngIf="!editMode">{{track.AdditionalStart}}</span>
              </td>
              <td>
                <input *ngIf="editMode" type="text" class="form-control" [(ngModel)]="track.TrackLength" required>
                <span *ngIf="!editMode">{{track.TrackLength}}</span>
              </td>
              <td *ngIf="editMode">
                <button class="btn btn-danger btn-sm" (click)="removeTrack(i)">
                  Remove
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
